import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const IconContainer = styled.button`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  background: var(--black-transparent);
  cursor: pointer;
  outline: none;
  transition: box-shadow 0.2s ease-in-out;

  :focus {
    box-shadow: 0 0 0px 3px rgba(0, 0, 0, 0.2);
  }
`;

export const DateInput = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  grid-template-rows: auto;
  margin-bottom: 20px;
  gap: 10px;
`;

export const SelectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  position: relative;
`;

export const Select = styled.select`
  width: 100%;
  height: 45px;
  font-size: 14px;
  padding: 10px 60px;
  color: var(--black-2);
  background: var(--white);
  border: 1px solid var(--gray-d);
  border-radius: 4px;
  outline: 0;
  transition: 0.2s ease;
  cursor: pointer;
  appearance: none;

  :focus {
    border: 1px solid var(--primary);
  }
`;

export const SelectIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  position: absolute;
  bottom: 13px;
  pointer-events: none;
  color: var(--black-2);
`;

export const NotFoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  color: var(--gray-9);

  > svg {
    margin-right: 8px;
  }
`;
